export { default } from './LoansTableItemProductDetail'
